import type { FC, ButtonHTMLAttributes, ReactNode } from "react";
import tw from "tailwind-styled-components";

const widthClasses: Record<string, string> = {
  "1/2": "w-1/2", // 50%
  "2/5": "w-2/5", // 40%
  "3/12": "w-3/12", // 25%
  full: "w-full", // 100%
};

interface CustomButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  typeButton?: "button" | "submit" | "reset";
  width?: "1/2" | "2/5" | "3/12" | "full" | string;
  disable?: boolean;
  handleClick?: () => void;
  styleRendering?: string;
  text: ReactNode;
}

const CustomButton: FC<CustomButtonProps> = ({
  typeButton = "button",
  width,
  disable = false,
  handleClick = () => {},
  styleRendering = "",
  text,
  ...props
}) => {
  const widthClass = width ? widthClasses[width] || "w-auto" : "w-auto";
  return (
    <Button
      type={typeButton}
      disabled={disable}
      onClick={handleClick}
      className={`${styleRendering} ${widthClass}`}
      styleprop={width}
      {...props}
    >
      {text}
    </Button>
  );
};

const Button = tw.button`
font-bold text-base text-white  
rounded-lg py-2 px-4  
shadow-sm shadow-gray-500
transition-all duration-300
ease-in-out transform
`;

export default CustomButton;
